import axios from 'axios';
import env from '../env';
import { getAuthToken } from '../commom/authToken';

const memoryAxiosInstance = axios.create({
  baseURL: env.REACT_APP_MEMORY_API,
});

/*
 *  adiciona o token de autenticação nas requisições
 * */
memoryAxiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

export default memoryAxiosInstance;
